import axios from "axios";

// Mounted on the API at /admin/coffee/greencoffee-bulk-imports.
// axios baseURL already includes /api/admin, so we only need the suffix.
const BASE = "/coffee/greencoffee-bulk-imports";

export default {
  /**
   * Upload + validate a file. `file` is a browser File object.
   * Returns the API envelope: { success, code, message, data }.
   */
  validateImport(file) {
    const formData = new FormData();
    formData.append("file", file);
    return axios
      .post(`${BASE}/validate`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /** Paginated import history. */
  getImportHistory(dataOptions = {}) {
    const requestParams = {
      page: dataOptions.page || 1,
      limit: dataOptions.itemsPerPage || dataOptions.limit || 10,
      search: dataOptions.search || undefined,
    };
    return axios
      .get(BASE, { params: requestParams })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /** A single import with its records. */
  getImportById(id) {
    return axios
      .get(`${BASE}/${id}`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /** Edit one record and re-validate it. `input` is the field-level payload. */
  updateRecord(recordId, input) {
    return axios
      .put(`${BASE}/records/${recordId}`, input)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /** Bulk soft-delete rows. */
  deleteRecords(bulkImportId, recordIds) {
    return axios
      .delete(`${BASE}/records`, { data: { bulkImportId, recordIds } })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  cancelImport(bulkImportId) {
    return axios
      .post(`${BASE}/${bulkImportId}/cancel`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /** Import all valid rows. Optionally pass { dryMillingUserId }. */
  runImport(bulkImportId, payload = {}) {
    return axios
      .post(`${BASE}/${bulkImportId}/import`, payload)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },
};
